import apiClient from '../lib/apiClient';

export async function updateMedicationReminder(
  id: number | undefined,
  taken_on: string
) {
  const response = await apiClient.put(
    `medication_reminders/${id}/mark_as_taken`,
    { taken_on: taken_on }
  );

  return response.data;
}
